import { Col, Row } from "antd";
import "./Register.scss";
import Depop from "../../assets/images/Header/logo.png";
import { Link } from "react-router-dom";
import FormRegister from "../../components/FormRegister";

function Register() {
  return (
    <>
      <Row className="register-wrapper">
        <Col xxl={12} xl={12} lg={12}>
          <div className="div-left">
            <img
              src="https://images.unsplash.com/photo-1755868769228-c79727676171?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjEyfHxzZWNvbmQlMjBoYW5kJTIwc2hvcHxlbnwwfHwwfHx8MA%3D%3D"
              alt="Image Register"
            />
          </div>
        </Col>

        <Col xxl={12} xl={12} lg={12} md={24}>
          <div className="div-right">
            <Link to="/">
              <div className="logo-register">
                <img src={Depop} alt="Logo Register" />
              </div>
            </Link>

            <div className="register-container">
              <div className="title">Đăng ký</div>
              <div className="sub">
                hoặc đã có tài khoản?
                <Link to="/login" className="login">
                  Đăng nhập
                </Link>
              </div>

              <FormRegister />
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default Register;
